import { render, staticRenderFns } from "./d-launched-review-activity.vue?vue&type=template&id=0840f20b&"
import script from "./d-launched-review-activity.vue?vue&type=script&lang=js&"
export * from "./d-launched-review-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports